/**
 * @generated SignedSource<<f1bba0ec8c67a4fe05c193ea20a4c78e>>
 * @relayHash a8c4454f25df6d929f9eb1e322e9cada
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1cd9eca42c709108c99f9ddf20faebeefea0dc583da0e021308d3fe45262dd8d

import type { ConcreteRequest } from 'relay-runtime';
export type useSpaceKeyWatcherContentSpaceKeyQuery$variables = {
  contentId: string;
};
export type useSpaceKeyWatcherContentSpaceKeyQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly space: {
        readonly alias: string | null | undefined;
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useSpaceKeyWatcherContentSpaceKeyQuery = {
  response: useSpaceKeyWatcherContentSpaceKeyQuery$data;
  variables: useSpaceKeyWatcherContentSpaceKeyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Literal",
        "name": "status",
        "value": [
          "current",
          "draft"
        ]
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "alias"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSpaceKeyWatcherContentSpaceKeyQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSpaceKeyWatcherContentSpaceKeyQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a8c4454f25df6d929f9eb1e322e9cada",
    "id": "1cd9eca42c709108c99f9ddf20faebeefea0dc583da0e021308d3fe45262dd8d",
    "metadata": {},
    "name": "useSpaceKeyWatcherContentSpaceKeyQuery",
    "operationKind": "query",
    "text": "query useSpaceKeyWatcherContentSpaceKeyQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\"]){nodes{id,space{id,key,alias}}}}"
  }
};
})();

(node as any).hash = "6b36a8d07cc501cdb430d7f11ca8944a";

export default node;
